import React from "react";
import SignupPopUp from "./SignupPopUp";
import { useDispatch, useSelector } from "react-redux";
import LoginPopUp from "./LoginPopUp";
import CreateCompanyPopUp from "./CreateCompanyPopUp";
import DialpadPopUp from "./DialpadPopUp";
import AddRequest from "./Requests/AddRequest";
import EditRequest from "./Requests/EditRequest";
import AddMember from "./Members/AddMember";
import EditMember from "./Members/EditMember";
import ConfigureNumberAllocation from "./NumberAllocation/ConfigureNumberAllocation";
import ChangeEmail from "./Settings/ChangeEmail";
import AddAiAgent from "./AiAgent/AddAiAgent";
import ActivityPopUp from "../PopUpSubModal/ActivityPopUp";
import { closeModal } from "../../features/modal/ModalSlice";
import EditNumberAllocation from "./NumberAllocation/EditNumberAllocation";
import EditAiAgent from "./AiAgent/EditAiAgent";
import OutBoundCallPopup from "../PopUpSubModal/OutBoundCallPopup";
import CommonCallForOutbondInbond from "../PopUpSubModal/CommonCallForOutbondInbond";

const OpenModal = () => {
  const modal = useSelector((state) => state?.modal?.modal);
  const dispatch = useDispatch();

  const handleCloseModal = () => {
    dispatch(closeModal());
  };

  return (
    <>
      <div
        className={modal?.isOpen ? "overFlowPoup" : ""}
        onClick={handleCloseModal}
      ></div>
      {modal?.subModal?.isOpen && (
        <>{modal?.subModal?.type === "ACTIVITY" && <ActivityPopUp />}</>
      )}
      {modal?.subModal?.isOpen && (
        <>{modal?.subModal?.type === "OUTBOUND" && <OutBoundCallPopup />}</>
      )}

      {modal?.subModal?.isOpen && (
        <>
          {modal?.subModal?.type === "COMMONCALL" && (
            <CommonCallForOutbondInbond />
          )}
        </>
      )}

      {modal?.isOpen && (
        <>
          {modal?.type === "SIGNUP" && <SignupPopUp />}
          {modal?.type === "LOGIN" && <LoginPopUp />}
          {modal?.type === "CREATE_COMPANY" && <CreateCompanyPopUp />}
          {modal?.type === "CALL_DIALPAD" && <DialpadPopUp />}
          {modal?.type === "ADD_REQUESTS" && <AddRequest />}
          {modal?.type === "EDIT_REQUESTS" && <EditRequest />}
          {modal?.type === "ADD_MEMBER" && <AddMember />}
          {modal?.type === "EDIT_MEMBER" && <EditMember />}
          {modal?.type === "CONFIGURE_NUMBER" && <ConfigureNumberAllocation />}
          {modal?.type === "EDIT_CONFIGURE_NUMBER" && <EditNumberAllocation />}
          {modal?.type === "CHANGE_EMAIL" && <ChangeEmail />}
          {modal?.type === "ADD_AI_AGENT" && <AddAiAgent />}
          {modal?.type === "EDIT_AI_AGENT" && <EditAiAgent />}
        </>
      )}
      {/* <DraggablePad /> */}
    </>
  );
};

export default OpenModal;
